import React, { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserRequestsLayout from './UserRequestsLayout';
import SupportRequests from './SupportRequests/SupportRequests';
import SupportRequestDetails from './SupportRequests/SupportRequestDetails/SupportRequestDetails';
import IntakeRequests from './IntakeRequest/IntakeRequests';
import RegistrationRequests from './RegistrationRequests/RegistrationRequests';
import { UserRequestsContextProvider } from './UserRequestsContext';
import IntakeRequestDetails from './IntakeRequest/IntakeRequestDetails';
import { useRequestNewCount } from './hooks';
import { RequestCounterKey } from './types';

export default function UserRequestsPage() {
  const { data: requestNewCount } = useRequestNewCount();

  const contextValue = useMemo(
    () => ({
      counters: {
        registration: requestNewCount?.[RequestCounterKey.SING_UP] ?? 0,
        support: requestNewCount?.[RequestCounterKey.SUPPORT] ?? 0,
        intake: requestNewCount?.[RequestCounterKey.INTAKE] ?? 0,
      },
    }),
    [requestNewCount],
  );

  return (
    <UserRequestsContextProvider value={contextValue}>
      <Routes>
        <Route path="/" element={<UserRequestsLayout />}>
          <Route index element={<Navigate to="registration" replace />} />
          <Route path="registration" element={<RegistrationRequests />} />
          <Route path="support" element={<SupportRequests />} />
          <Route path="intake" element={<IntakeRequests />} />
        </Route>
        <Route path="support/:id" element={<SupportRequestDetails />} />
        <Route path="intake/:id" element={<IntakeRequestDetails />} />
      </Routes>
    </UserRequestsContextProvider>
  );
}
